import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const ADVOCATE_PHOTO = "https://customer-assets.emergentagent.com/job_125d5d6b-1094-42f6-9b08-20887d6aee06/artifacts/5c8k3xwm_WhatsApp%20Image%202026-03-01%20at%2010.26.49.jpeg";
const HERO_BG = "https://images.unsplash.com/photo-1630928095945-7ce3e65c527a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjbGFzc2ljYWwlMjBjb3VydCUyMGJ1aWxkaW5nJTIwcGlsbGFycyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzIzNDEyMjh8MA&ixlib=rb-4.1.0&q=85&w=1920";

export const HeroSection = () => {
  const scrollToInquiry = () => {
    const element = document.getElementById('inquiry-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B1C2D]/95 via-[#0B1C2D]/90 to-[#0B1C2D]/80" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <div className="animate-fade-in-up">
              <p className="text-[#C6A34A] uppercase tracking-widest text-sm font-medium mb-4">
                Civil Lawyer | Patna High Court
              </p>
            </div>
            
            <h1 
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in-up animation-delay-100"
              style={{ fontFamily: "'Playfair Display', serif" }}
              data-testid="hero-title"
            >
              Adv. Ajeet Narayan Sinha
            </h1>
            
            <div className="w-20 h-1 bg-[#C6A34A] mb-6 animate-fade-in-up animation-delay-200" />
            
            <p className="text-lg sm:text-xl text-gray-300 mb-4 animate-fade-in-up animation-delay-200">
              <span className="text-[#C6A34A] font-semibold">35+ Years</span> of Practice
            </p>
            
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-8 max-w-lg animate-fade-in-up animation-delay-300">
              Adv. Ajeet Narayan Sinha is a senior civil law practitioner based in Patna 
              with almost four decades of experience representing clients before the 
              Patna High Court and other civil courts in Bihar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
              <Button 
                onClick={scrollToInquiry}
                className="bg-[#C6A34A] hover:bg-[#D4B055] text-white px-8 py-6 text-base font-medium shadow-lg hover:shadow-xl transition-all"
                data-testid="hero-cta-btn"
              >
                Submit Legal Query
              </Button>
              <Button 
                onClick={scrollToAbout}
                variant="outline"
                className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-base font-medium"
                data-testid="hero-learn-more-btn"
              >
                Learn More
              </Button>
            </div>
          </div>

          {/* Advocate Photo */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end animate-fade-in-up">
            <div className="relative">
              {/* Decorative frame */}
              <div className="absolute -inset-4 border-2 border-[#C6A34A]/30 transform rotate-3" />
              <div className="absolute -inset-4 border-2 border-[#C6A34A]/20 transform -rotate-2" />
              
              <img 
                src={ADVOCATE_PHOTO}
                alt="Adv. Ajeet Narayan Sinha - Civil Lawyer, Patna High Court"
                className="relative w-64 h-80 sm:w-72 sm:h-96 lg:w-80 lg:h-[420px] object-cover object-top border-4 border-[#C6A34A] shadow-2xl"
                data-testid="advocate-photo"
              />
              
              {/* Experience badge */}
              <div className="absolute -bottom-4 -left-4 bg-[#0B1C2D] border-2 border-[#C6A34A] px-6 py-3 shadow-xl">
                <p className="text-[#C6A34A] text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>35+</p>
                <p className="text-white text-xs uppercase tracking-wider">Years Practice</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button 
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 hover:text-[#C6A34A] transition-colors animate-bounce"
        aria-label="Scroll down"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
};
